var map = {
	"./animal.svg": 320,
	"./arrow.svg": 321,
	"./bicycle.svg": 322,
	"./boat.svg": 323,
	"./bus.svg": 324,
	"./car.svg": 325,
	"./crane.svg": 326,
	"./default.svg": 327,
	"./helicopter.svg": 328,
	"./motorcycle.svg": 329,
	"./offroad.svg": 330,
	"./person.svg": 331,
	"./pickup.svg": 332,
	"./plane.svg": 333,
	"./ship.svg": 334,
	"./tractor.svg": 335,
	"./train.svg": 336,
	"./tram.svg": 337,
	"./trolleybus.svg": 338,
	"./truck.svg": 339,
	"./van.svg": 340
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 804;